import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '西方古典绘画', path: '/category/western-classical' },
  { name: '东方艺术', path: '/category/eastern-art' },
  { name: '现代摄影', path: '/category/modern-photography' },
  { name: '雕塑艺术', path: '/category/sculpture' },
  { name: '当代艺术', path: '/category/contemporary-art' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`text-lg font-heading whitespace-nowrap tracking-wide transition-colors duration-300 ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            裸体艺术解析
          </Link>

          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm whitespace-nowrap rounded-md transition-colors duration-200 ${
                  location.pathname === link.path
                    ? isScrolled || !isHome
                      ? 'text-primary-500 bg-primary-100/70 font-medium'
                      : 'text-white bg-white/20 font-medium'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <button
            className={`lg:hidden w-8 h-8 flex items-center justify-center rounded-md transition-colors ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="lg:hidden border-t border-background-200/70 bg-background-50 pb-4">
            <div className="flex flex-col pt-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2.5 text-sm rounded-md transition-colors ${
                    location.pathname === link.path
                      ? 'text-primary-500 bg-primary-100/70 font-medium'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}